import { AdobeConfig } from '@wakanda/adobe-analytics';
import { environment } from '@wakanda/environment-avo-business/environment';

export const adobeConfig: AdobeConfig = {
  app: environment.adobeApp,
};
